import * as Dialog from '@radix-ui/react-dialog'
import { XClear } from '@/assets/icons'
import { useEffect, useRef } from 'react'
import { selectConversationSelectedFiles } from '@/chat-common/selected_files/store/selectors'
import { useAppSelector } from '@/store/store-hooks'
import { RootState } from '@/store/store'
import { FileUploadStatusListInChat } from './FileUploadStatusListInChat'
import { selectFileUploadTasksWithKeys } from '@/store/selectors/file-upload-tasks-reducers.selector'

interface FileUploadStatusDialogProps {
  open: boolean
  conversationId: string
  onClose: () => void
}

const FileUploadStatusDialogInChat = (props: FileUploadStatusDialogProps) => {
  const { open, onClose, conversationId } = props

  // Get the filePath values
  const selectedFiles = useAppSelector((state: RootState) => selectConversationSelectedFiles(state, { conversationId }))

  // Select the upload tasks for these filePaths
  const uploadTasks = useAppSelector((state: RootState) => selectFileUploadTasksWithKeys(state, { keys: selectedFiles }))

  // Convert the upload tasks to an array for rendering a list
  const tasks = Object.values(uploadTasks)

  // Scroll to the bottom of the list when tasks update
  const scrollRef = useRef<HTMLDivElement>(null)
  useEffect(() => {
    if (scrollRef.current) {
      scrollRef.current.scrollTo({ top: scrollRef.current.scrollHeight, behavior: 'smooth' })
    }
  }, [tasks])

  const completedTasks = Array.from(tasks.values()).filter((task) => task.complete).length

  return (
    <Dialog.Root open={open} onOpenChange={onClose}>
      <Dialog.Portal>
        <Dialog.Content className="fixed top-[50%] left-[50%] pb-4 lg:left-[calc(50%+248px)] max-h-[85vh] w-[90vw] max-w-[450px] translate-x-[-50%] translate-y-[-50%] rounded-[6px] bg-brand-neutral-50 p-[25px] shadow-[0_10px_38px_-10px_rgba(0,0,0,0.35),_0_10px_20px_-15px_rgba(0,0,0,0.2)] focus:outline-none">
          <div className="flex justify-between items-center mb-2">
            <Dialog.Title className="m-0 text-[17px] font-medium text-brand-neutral-800">
              {completedTasks} {completedTasks === 1 ? 'upload' : 'uploads'} complete
            </Dialog.Title>
            <Dialog.Close asChild autoFocus>
              <button
                className="inline-flex items-center justify-center rounded-full text-brand-neutral-700 hover:text-brand-neutral-900"
                onClick={onClose}
                aria-label="Close"
              >
                <XClear className="w-5 h-5" />
              </button>
            </Dialog.Close>
          </div>
          <hr className="mt-4" />
          <div className="text-[15px] leading-normal">
            <FileUploadStatusListInChat tasks={tasks} scrollRef={scrollRef} />
          </div>
        </Dialog.Content>
      </Dialog.Portal>
    </Dialog.Root>
  )
}

export { FileUploadStatusDialogInChat }
